import {
  employeeProgramRequiredCompanyFundAccountReady,
  employeeProgramRequiredCompanyUser,
  employeeProgramRequiredCompanyUserVerified,
  employeeProgramRequiredEmployeeFundAccountReady,
  employeeProgramRequiredEmployeeUser,
  employeeProgramRequiredEmployeeUserVerified,
  employeeProgramRequiredInvestmentPlan,
  employeeProgramRequiredStartDateEndDateValid,
} from 'apps/investment/constants/employeeProgram';

export const programRequirements = [
  {
    label:
      'Doanh nghiệp phải tạo chương trình và NV tham gia (nhập mã tham gia hợp lệ) vào chương trình',
    condition: employeeProgramRequiredEmployeeUser,
  },
  {
    label:
      'Ngày bắt đầu của chương trình đã kích hoạt (đạt hoặc vượt qua) và chưa đến thời điểm / ngày kết thúc',
    condition: employeeProgramRequiredStartDateEndDateValid,
  },
  {
    label:
      'Nhân viên phải hoàn thành việc chọn danh mục đầu tư (bao gồm đạt các yêu cầu về chọn giá trị đầu tư định kỳ tối thiểu)',
    condition: employeeProgramRequiredInvestmentPlan,
  },
];

export const accountRequirements = [
  {
    label: 'Doanh nghiệp có tài khoản Stag active',
    condition: employeeProgramRequiredCompanyUser,
  },
  {
    label:
      'Doanh nghiệp phải hoàn thành định danh level 3 trên hệ thống Stag (email, phone, eKYC)',
    condition: employeeProgramRequiredCompanyUserVerified,
  },
  {
    label:
      'Doanh nghiệp phải hoàn thành mở tài khoản giao dịch CCQ tại cty QLQ được Nhân viên lựa chọn trong danh mục',
    condition: employeeProgramRequiredCompanyFundAccountReady,
  },
  {
    label:
      'Doanh nghiệp được gắn kết nối giữa tài khoản Stag và tài khoản giao dịch CCQ',
    condition: employeeProgramRequiredCompanyFundAccountReady,
  },
  {
    label: 'Nhân viên có tài khoản Stag active',
    condition: employeeProgramRequiredEmployeeUser,
  },
  {
    label:
      'Nhân viên hoàn thành định danh level 3 trên hệ thống Stag (email, phone, eKYC)',
    condition: employeeProgramRequiredEmployeeUserVerified,
  },
  {
    label:
      'Nhân viên hoàn thành mở tài khoản giao dịch CCQ tại cty QLQ được Nhân viên lựa chọn trong danh mục',
    condition: employeeProgramRequiredEmployeeFundAccountReady,
  },
  {
    label:
      'Nhân viên được gắn kết nối giữa tài khoản Stag và tài khoản giao dịch CCQ',
    condition: employeeProgramRequiredEmployeeFundAccountReady,
  },
];
